<!-- Footer -->
<footer id="footer" class="footer_area">
    <!-- Need help getting started? -->
    <div id="getstarted" class="fc_footer_top">
        <div class="content_width text-center">
            <div class="contact_info">
                <h2 class="heading3 white-text">Our Commitment to you</h2>
                <p class="white-text mb-0">We keep your information safely stored, at your fingertips, so you can focus
                    on what matter most — <strong><em class="text-bold">your family.</em></strong></p>
            </div>
        </div>
    </div>

    <div class="fc_footer">
        <div class="footer_content content_width">
            <div class="footer_widgets d-flex justify-content-between" id="footerAccordion">
                <div class="single_widget fc_footer_nav first_widget">
                    <a class="widget_heading" routerLink="/"><img width="155" height="88"
                            src="/assets/images/family-central-white.svg" alt="Family Central" loading="lazy"></a>
                    <div>
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link"
                                    href="mailto:hello&#64;familycentral.com">Hello&#64;familycentral.com</a></li>
                            <li class="nav-item"><a class="nav-link" href="tel:1.888.780.Family">1.888.780.Family</a>
                            </li>
                            <li class="nav-item app_store">
                                <a class="nav-link"
                                    href="https://apps.apple.com/in/app/familycentral-family-office/id6476486249"
                                    target="_blank" rel="noopener"><img src="/assets/images/apple-download-badge.svg"
                                        alt="Download apple" loading="lazy"></a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="newsletters d-block d-md-none">
                    <button type="button" class="info_btn nav-link text_white" (click)="newslettersupdate()">Sign Up for
                        Newsletters</button>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseTwo">COMPANY</a>
                    <div id="collapseTwo" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link" href="/aboutus">About Us</a></li>
                            <li class="nav-item"><a class="nav-link" href="/aboutus#ourTeam">Our Team</a></li>
                            <li class="nav-item"><a class="nav-link" href="/aboutus#ourStory">Our Story</a></li>
                        </ul>
                    </div>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseThree">PRODUCT</a>
                    <div id="collapseThree" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link" routerLink="/price-details">Pricing</a></li>
                            <li class="nav-item"><a class="nav-link" routerLink="/security">Security</a></li>
                        </ul>
                    </div>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseFour">SUPPORT</a>
                    <div id="collapseFour" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link" routerLink="/contactus">Contact Us</a></li>
                            <li class="nav-item"><a class="nav-link" routerLink="/faq">FAQs</a></li>
                        </ul>
                    </div>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseFive">PARTNER WITH US</a>
                    <div id="collapseFive" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link" routerLink="/refer-a-friend">Refer-a-Friend</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseSix">LEGAL</a>
                    <div id="collapseSix" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item"><a class="nav-link" routerLink="/privacy-policy">Privacy Policy</a>
                            </li>
                            <li class="nav-item"><a class="nav-link" routerLink="/termsconditions">Terms &
                                    Conditions</a></li>
                            <li class="nav-item"><a class="nav-link" routerLink="/underconstruction">Accessibility</a>
                            </li>
                            <li class="nav-item"><a class="nav-link" routerLink="/gdpr">GDPR</a></li>
                            <li class="nav-item"><a class="nav-link" routerLink="/ccpa">CCPA</a></li>
                        </ul>
                    </div>
                </div>

                <div class="single_widget fc_footer_nav">
                    <a class="widget_heading" data-bs-toggle="collapse" href="#collapseSeven">Connect</a>
                    <div id="collapseSeven" class="collapse" data-bs-parent="#footerAccordion">
                        <ul class="widget_links">
                            <li class="nav-item">
                                <a class="nav-link" href="https://www.instagram.com/familycentralapp/" target="_blank" rel="noopener">
                                    <span class="social_icon"><img src="/assets/images/instagram-icon.svg" alt=""
                                            loading="lazy"></span>Instagram
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="https://www.facebook.com/profile.php?id=61554336248390"
                                    target="_blank" rel="noopener">
                                    <span class="social_icon"><img src="/assets/images/facebook-icon.svg" alt=""
                                            loading="lazy"></span>Facebook
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link"
                                    href="https://in.linkedin.com/company/familycentral?trk=public_profile_experience-item_profile-section-card_subtitle-click"
                                    target="_blank" rel="noopener">
                                    <span class="social_icon"><img src="/assets/images/linkedin-icon.svg" alt=""
                                            loading="lazy"></span>LinkedIn
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="newsletters d-none d-md-block">
                    <a class="nav-link" (click)="newslettersupdate()">Sign Up for Newsletters</a>
                </div>

            </div>

            <div
                class="fc_footer_nav footer_copyright d-flex justify-content-between align-items-center flex-column-reverse flex-md-row">
                <ul class="footer_nav">
                    <li class="nav-item">Family Central &copy;2023</li>
                </ul>
                <ul class="security_logos d-flex align-items-center">
                    <li class="nav-item"><img src="/assets/images/hipaa-complaint.svg" alt="Hipaa Complaint"
                            loading="lazy"></li>
                    <li class="nav-item"><img src="/assets/images/gdrp-ready.svg" alt="GDRP Ready" loading="lazy"></li>
                    <li class="nav-item"><img src="/assets/images/ccpa-ready.svg" alt="CCAP Ready" loading="lazy"></li>
                    <li class="nav-item"><img src="/assets/images/secured-by-sectigo.svg" alt="Secured By Sectigo"
                            loading="lazy"></li>
                    <li class="nav-item"><img src="/assets/images/duns-registered.svg" alt="D-N-U-S Registered"
                            loading="lazy"></li>
                </ul>
            </div>
        </div>
    </div>
</footer>
